import { notification } from "antd";
import { ApolloError } from "apollo-boost";
import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { USstates } from "../../common/Data";
import { Store } from "../Store";
import { CommunitiesStore } from "./CommunitiesStore";

export class CommunityEditStore {
  store: CommunitiesStore;

  id?: string = undefined;
  visible = false;
  loading = false;
  saving = false;
  model?: any;

  childcareFares: string[] = [];

  constructor(store: CommunitiesStore) {
    makeAutoObservable(this, {
      store: false,
    });
    this.store = store;
    // this.childcareFare();
  }

  get divisions() {
    return Store.adminStore.divisionStore.divisions;
  }

  // get cityList() {
  //   return stateCities[this.model?.state] || [];
  // }

  states = Object.entries(USstates).map(([key, value]) => ({
    key,
    value,
  }));

  @action
  reload(id) {
    this.loading = true;
    Api.community
      .community(id)
      .then((res) => {
        runInAction(() => {
          this.model = res.data.community;
        });
      })
      .finally(() => (this.loading = false));
  }

  @action childcareFare() {
    return Api.community.childcareFare().then((res) => {
      runInAction(() => {
        this.childcareFares = res.data.childcareFare;
      });
    });
  }

  @action
  async new() {
    await Store.adminStore.divisionStore.refresh();
    await this.childcareFare();
    this.id = undefined;
    this.model = { status: "Inactive" };
    this.visible = true;
  }

  @action
  async edit(id) {
    await Store.adminStore.divisionStore.refresh();
    await this.childcareFare();
    this.id = id;
    this.visible = true;
    this.reload(id);
  }

  @action
  save(values) {
    const zipCodes = Array.from(new Set((values.zipCodes || []).filter((x) => !!x)));
    this.saving = true;
    return Api.community
      .saveCommunity({ ...values, zipCodes, id: this.id })
      .then((res) => {
        this.visible = false;
        notification.success({ message: `Community ${values.name} saved` });
        setTimeout(() => {
          this.store.refresh();
        }, 3000);
      })
      .catch((err: ApolloError) => {})
      .finally(() => (this.saving = false));
  }

  @action
  close() {
    this.visible = false;
  }
}
